
import React from 'react';
import { Link } from 'react-router-dom';

const OtherToursSection = () => {
  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="font-playfair font-bold text-2xl md:text-3xl mb-8 text-[#3E2723] text-center">
          Explore Our Other Tours
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          <div className="bg-[#FAF2E8] p-6 rounded-lg border border-[#C58B65]/10 shadow-sm hover:shadow-md transition-all">
            <h3 className="font-playfair font-bold text-xl mb-3 text-[#3E2723]">Brooklyn Heights</h3>
            <p className="mb-4 text-[#3E2723]/80 font-montserrat">
              Stroll through America's first suburb and discover its historical feline legends from the 1800s, from historic brownstones to the famous Promenade.
            </p>
            <Link to="/tours/brooklyn-heights" className="text-[#D32F2F] hover:underline font-montserrat block text-center">
              View Tour
            </Link>
          </div>
          
          <div className="bg-[#FAF2E8] p-6 rounded-lg border border-[#C58B65]/10 shadow-sm hover:shadow-md transition-all">
            <h3 className="font-playfair font-bold text-xl mb-3 text-[#3E2723]">Lower East Side</h3>
            <p className="mb-4 text-[#3E2723]/80 font-montserrat">
              Explore the gritty historical feline tales of NYC's most colorful neighborhood, from 19th century tenement cats to legendary bar mascots of the past.
            </p>
            <Link to="/tours/lower-east-side" className="text-[#D32F2F] hover:underline font-montserrat block text-center">
              View Tour
            </Link>
          </div>
          
          <div className="bg-[#FAF2E8] p-6 rounded-lg border border-[#C58B65]/10 shadow-sm hover:shadow-md transition-all">
            <h3 className="font-playfair font-bold text-xl mb-3 text-[#3E2723]">Private Tours</h3>
            <p className="mb-4 text-[#3E2723]/80 font-montserrat">
              Create a customized cat history experience for your group, tailored to your interests and schedule.
            </p>
            <Link to="/tours/private-tours" className="text-[#D32F2F] hover:underline font-montserrat block text-center">
              View Options
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OtherToursSection;
